import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { getAllArticles, sortByLatest } from "@/lib/articles";
import { topics } from "@/mocks/topics";

const tabs = [{ slug: "all", name: "全部" }, ...topics.map((t) => ({ slug: t.slug, name: t.name }))];

export default function LatestSection() {
  const [active, setActive] = useState("all");
  const [visibleCount, setVisibleCount] = useState(6);

  const list = useMemo(() => {
    const all = sortByLatest(getAllArticles());
    const filtered = active === "all" ? all : all.filter((a) => a.topic === active);
    return filtered;
  }, [active]);

  const shown = list.slice(0, visibleCount);

  return (
    <section className="bg-background-50 px-4 py-12 md:px-6 md:py-16" aria-label="最新爆料">
      <div className="shell">
      <SectionHeading
        eyebrow="Daily Feed"
        title="最新爆料"
        desc="按发布时间排序的当日更新，每条都标注了可信度等级，方便你判断信息分量。"
        action={
          <div className="flex flex-wrap items-center gap-1 rounded-full border border-background-200 bg-background-100 p-1">
            {tabs.map((tab) => (
              <button
                key={tab.slug}
                type="button"
                onClick={() => {
                  setActive(tab.slug);
                  setVisibleCount(6);
                }}
                className={`cursor-pointer whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-label font-bold transition-colors ${
                  active === tab.slug
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-primary-600"
                }`}
              >
                {tab.name}
              </button>
            ))}
          </div>
        }
      />

      {shown.length > 0 ? (
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 md:gap-6">
          {shown.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
      ) : (
        <p className="rounded-lg border border-dashed border-background-300 bg-background-100 py-16 text-center text-sm text-foreground-500">
          该主题暂时没有新的爆料，换个分类看看
        </p>
      )}

      <div className="mt-8 flex justify-center">
        {visibleCount < list.length ? (
          <button
            type="button"
            onClick={() => setVisibleCount((c) => c + 3)}
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-foreground-300 px-6 py-2.5 text-sm font-label font-bold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            加载更多爆料
            <i className="ri-arrow-down-line" aria-hidden="true" />
          </button>
        ) : (
          <Link
            to="/topic/shoufa"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-6 py-2.5 text-sm font-label font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            进入首发追踪栏目
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        )}
      </div>
      </div>
    </section>
  );
}